<div class="contextual-not-found-container">
  <h1>{{ "page-not-found.not-found-title" | translate }}</h1>

  <p>{{ "page-not-found.not-found-message" | translate }}</p>

  <sui-button variant="secondary" (click)="goHome()">
    {{ ("page-not-found.go-to" | translate) + " " + displayName }}
  </sui-button>

  @if (currentModule !== "analytics" && currentModule !== "auth") {
    <sui-button variant="secondary" (click)="goToMainDashboard()">
      {{ "page-not-found.go-to-analytics-home" | translate }}
    </sui-button>
  }
  <p>
    {{ "page-not-found.curren-module" | translate }}
    <strong>{{ displayName }}</strong>
  </p>
</div>
